<template>
  <div @keydown.esc="()=>cancel()">
    <input
      class="title"
      v-model="title"
      @keydown.enter="()=>save(trip.id, title)"
    />
    <button
      class="primary"
      @click="save(trip.id, title)"
    >Gem</button>
  </div>
</template>

<script>
export default {
  name: 'title-edit',
  props: {
    cancel: Function,
    save: Function,
    trip: Object,
  },
  data: function() {
    return { title: this.trip.title };
  },
};
</script>

<style lang="scss" scoped>
input {
  width: 85%;
  padding: 9px;
  margin-top: -9px;
  font-size: 18px;
  font-weight: 600;
  font-family: 'Open Sans', sans-serif;
  border-radius: 3px;
  background: #f7f7fa;
  border: 1px solid #f7f7fa;
  color: $primary-700;
  &:focus {
    border: 1px solid #6a72a6;
    outline: none;
  }
}
button {
  width: 15%;
  height: 45px;
  line-height: 45px;
  background-color: $primary-700;
  border-radius: 3px;
  color: #fff;
  font-size: 16px;
  padding: 0;
  font-weight: 600;
  cursor: pointer;
  margin-left: -4px;
  border: 1px solid $primary-700;
  &:hover {
    box-shadow: 0 2px 10px 0 rgba(15, 28, 112, 0.251);
  }
}
</style>
